export const LINE_MANAGERS_CATEGORY = 'made-for-managers';
